import React, { useEffect, useState } from "react";
import "./Content.css";
import { connect } from "react-redux";
import { Modal } from "react-responsive-modal";

import { FaRupeeSign } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
// import Loader from "../components/Loader/Loader.js";
import Loader from "../../../components/Loader/Loader";
// import cart_gray from "../../../Assets/cart_gray.svg";
import cart_empty from "../../../Assets/cart_empty.svg";
import cart_fill from "../../../Assets/cart_fill.svg";
//importing CARASOUL
// import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import { SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS } from "../../../Redux/Constants";
import {
  AddtoCart,
  getCartDetails,
  getPackageList,
  getAllImagingPackageList,
  ImagingPackageList,
  Imaginetestimonials,
} from "../../../Redux/Actions";
import { GiConvergenceTarget } from "react-icons/gi";
import AddressPopUp from "../../../components/Redcliffe-Imaging/AddressPopUp";
import FooterForm from "../../../components/Footer/FooterForm";
// import BookSlide from "../../AddressSlider/BookSlide";

// for the notification
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

//RESPONSIVE SCRRREN
// const responsive = {
//   superLargeDesktop: {
//     // the naming can be any, depends on you.
//     breakpoint: { max: 4000, min: 3000 },
//     items: 5,
//   },
//   desktop: {
//     breakpoint: { max: 3000, min: 1024 },
//     items: 3,
//   },
//   tablet: {
//     breakpoint: { max: 1024, min: 464 },
//     items: 3,
//   },
//   mobile: {
//     breakpoint: { max: 464, min: 0 },
//     items: 1,
//   },
// };

function OurPackages(props) {
  //   const [pack, setPack] = useState([]);
  const packageList = useSelector((state) => state.ImgPackagesReducer);
  // console.log(packageList?.ImgPackages?.details, "<<<<<<");
  // const USP = JSON.parse(packageList?.ImgPackages?.details);
  //   const [openCartt, setOpenCartt] = useState(false);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const [cartisempty, setcartisempty] = useState(true);
  //   const onCloseModalCartt = () => setOpenCartt(false);
  const [ItemInCart, setItemInCart] = useState([]);

  const { loading, packages } = packageList;
  //   const { results } = packages;
  const location = useLocation();

  const prePack = location?.pathname !== "/";

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    let newArray = [];
    if (props.CartItem && props.CartItem[0] && props.CartItem[0]?.product) {
      props.CartItem[0]?.product.map((item) => {
        newArray.push(item.package.id);
      });
      setItemInCart(newArray);
    }
  }, [props.CartItem]);

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;
    dispatch(getCartDetails(token, citySelected?.citySelect));
  };

  const isLogout = useSelector((state) => state.setLogoutReducer);
  const [greenCart, setGreenCart] = useState("");
  useEffect(() => {
    if (isLogout.isLogout == "") {
      if (JSON.parse(localStorage.getItem("user"))) {
        setGreenCart(true);
      } else {
        setGreenCart(false);
      }
    } else if (isLogout.isLogout == true) {
      setGreenCart(false);
    } else {
      setGreenCart(true);
    }
  }, [isLogout]);

  function addtocart(packageid, packageslug) {
    console.log("runned");
    setcartisempty(false);
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    const token = userFromLocal && userFromLocal.token;
    const body = {
      package: packageid,
    };
    if (token && token !== "") {
      dispatch(AddtoCart(body, token, successCb));
    } else {
      localStorage.setItem("packId", JSON.stringify(packageid));
      history.push({
        pathname: "/login",
        packageId: packageid,
      });
    }
    localStorage.setItem("packageSlug", packageslug);
  }
  const [firstScroll, setFirstScroll] = useState(false);
  const [hideDiv, setHideDiv] = useState(false);
  const [hideRightBtn, setHideRightBtn] = useState(true);
  // const Mobwidth = screen.width;
  const cardScroll = () => {
    const scrollPos = window.document.querySelector(".newProductListingCards");
    scrollPos.addEventListener(
      "scroll",
      (event) => {
        if (scrollPos.scrollLeft < 50) {
          setHideRightBtn(true);
          setFirstScroll(false);
        } else {
          setHideRightBtn(false);
        }
        if (scrollPos.scrollLeft > 100) {
          setHideDiv(true);
        } else {
          setHideDiv(false);
        }
      },
      { passive: true }
    );
  };
  const scrollLeft = () => {
    const scrollPos = window.document.querySelector(".newProductListingCards");
    if (screen.width > 1500) {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.17;
      } else {
        scrollPos.scrollLeft += 390;
      }
    } else if (screen.width < 1500 && screen.width > 1280) {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.177;
      } else {
        scrollPos.scrollLeft += 390;
      }
    } else if (screen.width < 1280 && screen.width > 700) {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.19;
      } else {
        scrollPos.scrollLeft += 312;
      }
    } else {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.88878;
      } else {
        scrollPos.scrollLeft += screen.width * 0.88878;
      }
    }
  };
  const scrollRight = () => {
    const scrollPos = window.document.querySelector(".newProductListingCards");
    if (screen.width > 1280) {
      scrollPos.scrollLeft -= 390;
    } else if (screen.width < 1280 && screen.width > 700) {
      scrollPos.scrollLeft -= 312;
    } else {
      scrollPos.scrollLeft -= screen.width * 0.87878;
    }
  };

  const [Mobwidth, setMobWidth] = useState("");

  useEffect(() => {
    function updateSize() {
      // if (typeof window !== "undefined") {
      setMobWidth(window.screen.width);
      // }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const [cartClick, setCartClick] = useState(false);
  const [cartId, setCartId] = useState("");
  const [cardSlug, setCardSlug] = useState("");

  const handleBookNow = (card, loc) => {
    if (loc && loc == "cart") {
      setCartClick(true);
      setCartId(card.id);
    } else {
      setCartClick(false);
    }
    setCardSlug(card.slug);
    dispatch({
      type: SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS,
    });
    onOpenModal();
  };
  const [open, setOpen] = useState(false);

  const onOpenModal = () => {
    setOpen(true);
  };
  const onCloseModal = () => setOpen(false);

  const viewAllPackages = () => {
    history.push("/imaging/health-checkup-packages");
  };
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [pacCardBs, setPackCardBs] = useState("");
  console.log("modal View", open);
  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="BackgroundForImagingPage">
        <div className={hideDiv ? "newPackageListingBg" : "newPackageListing"}>
          <div
            className={
              hideDiv
                ? "bestPackagesTitle bestPackagesTitleHide"
                : "bestPackagesTitle"
            }
          >
            <div className="trustedLabDiv">
              <img
                style={{ width: "30px" }}
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/516ee914-9798-4d7e-b438-cdeaac91e30d.svg"
                alt=""
              />
              &nbsp;
              <span className="trustedLabTxt"> India's Most</span>
              <span className="trustedLabTxt"> Trusted Imaging Labs</span>
              <div className="bestHealthPackagesDiv">Our Top Tests</div>
            </div>
            <div className="bestHealthPackagesDiv"></div>
          </div>
          <div className="bestPackagesTitleMobile">
            <div className="trustedLabDiv">
              <div className="bestHealthPackagesDiv">Our Top Tests</div>

              {/* &nbsp; */}
              <span className="trustedLabTxt">
                <img
                  style={{ width: "20px" }}
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/516ee914-9798-4d7e-b438-cdeaac91e30d.svg"
                  alt=""
                />
                India's Most Trusted Imaging Labs
              </span>
              {/* <span className="trustedLabTxt"> </span> */}
            </div>
          </div>
          {/* <Carousel
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2500}
          transitionDuration={200}
          deviceType={"tablet"}
        >
         
        </Carousel> */}
          <div className="newProductListingCards" onScroll={cardScroll}>
            {packageList?.ImgPackages &&
              packageList?.ImgPackages &&
              packageList?.ImgPackages?.map((card, i) => {
                var USP = [
                  "Lady technician available",
                  "Parking Facility",
                  "100% Covid Safe",
                ];
                try {
                  if (card?.text_criteria && card?.text_criteria != "") {
                    var USP = JSON.parse(card?.text_criteria);
                  }
                } catch {
                  console.log();
                  var USP = [
                    "Lady technician available",
                    "Parking Facility",
                    "100% Covid Safe",
                  ];
                }
                return (
                  <div
                    className={
                      // card?.is_premium && prePack
                      // ? i + 1 == packageList.ImgPackages.length
                      //   ? "Package__card Package__cardNew bgPremium lastCardMobile"
                      //   : "Package__card Package__cardNew bgPremium "
                      i + 1 == packageList?.ImgPackages?.length
                        ? "Package__card Package__cardNew bgOrdinary lastCardMobile"
                        : "Package__card Package__cardNew bgOrdinary"
                    }
                    key={card.id}
                  >
                    <div
                      // className={
                      //   card?.is_premium && prePack
                      //     ? "packageTopP packageTopHeight"
                      //     : "packageTopO packageTopHeight"
                      // }
                      className="packageTopO packageTopHeight"
                    >
                      <div>
                        <div className="Package__cardTitle Package__cardPadding  blogPackageTitle blogPackageTitleNew">
                          <span
                            // className={
                            //   card?.is_premium && prePack
                            //     ? "textWhite"
                            //     : "textBluee txtBlack"
                            // }
                            className="textBluee txtBlack"
                          >
                            {/* <Link
                          className={
                            card?.is_premium && prePack
                              ? "textWhite"
                              : "textBluee txtBlack"
                          }
                          to={`/Imaging/${card.slug}${
                            citySelected.citySelect != ""
                              ? `-${citySelected.citySelect
                                  .toLowerCase()
                                  .replace(" ", "-")}`
                              : ""
                          }`}
                        > */}
                            {card.name.length < 47
                              ? card.name
                              : `${card.name.substring(0, 47)}...`}
                            {/* </Link> */}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="packageBottom packageBottomNew">
                      <div className="Package__cardList Package__cardList2 Package__cardListNew">
                        <ul>
                          {USP?.map((item, index) => {
                            return (
                              <li>
                                {" "}
                                <img
                                  className="checkIconProductListing"
                                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                                  alt=""
                                />
                                {item}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <hr style={{ width: "100%", opacity: "0.3" }} />

                      <div className="Package__cardPrice Package__cardPriceNew">
                        <span
                          // className={
                          //   card.is_premium && prePack
                          //     ? " card__offerPrice textSizeSmall "
                          //     : "   card__offerPrice textGrey textSizeSmall"
                          // }
                          className="   card__offerPrice textGrey textSizeSmall"
                        >
                          {" "}
                          Starts from :
                          <div className="newOfferPriceValue">
                            &#8377;{card?.offer_price}{" "}
                            <span className="overlinedPriceNew">
                              &#8377;{card?.package_price}
                            </span>
                          </div>
                        </span>
                      </div>

                      {cartisempty != false ? (
                        <div className="newCardBottom">
                          <button
                            className="imagingBtn"
                            onClick={() => {
                              handleBookNow(card);
                            }}
                          >
                            BOOK NOW
                          </button>
                          {/* <div
                            className="cart_div cart_textHeight cart_textHeightImg "
                            onClick={() => handleBookNow(card, "cart")}
                          >
                            <div
                              //  className={
                              //    card?.is_premium ? "hover_blue" : "hover_gray"
                              //  }
                              className="hover_gray"
                            >
                              {ItemInCart.includes(card?.id) ? (
                                <img
                                  //  className={
                                  //    card?.is_premium
                                  //      ? "cartImageWidth cartImageWidthBlue"
                                  //      : "cartImageWidth"
                                  //  }
                                  className="cartImageWidth"
                                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                                  alt="cart icon"
                                />
                              ) : (
                                <img
                                  //  className={
                                  //    card?.is_premium
                                  //      ? "cartImageWidth cartImageWidthBlue"
                                  //      : "cartImageWidth"

                                  //  }
                                  className="cartImageWidth"
                                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                                  alt="cart icon"
                                />
                              )}
                            </div>
                          </div> */}
                        </div>
                      ) : (
                        // <div className="newCardBottom">
                        <div
                          className="newCardBottom"
                          onClick={() => {
                            handleBookNow(card);
                          }}
                        >
                          <button className="imagingBtn">BOOK NOW</button>
                          <div
                            className="cart_div cart_textHeight cart_textHeightImg "
                            onClick={() => handleBookNow(card, "cart")}
                          >
                            <div
                              // className={
                              //   card?.is_premium ? "hover_blue" : "hover_gray"
                              // }
                              className="hover_gray"
                            >
                              {ItemInCart.includes(card?.id) ? (
                                <img
                                  // className={
                                  //   card?.is_premium
                                  //     ? "cartImageWidth cartImageWidthBlue"
                                  //     : "cartImageWidth"
                                  // }
                                  className="cartImageWidth"
                                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                                  alt="cart icon"
                                />
                              ) : (
                                <img
                                  // className={
                                  //   card?.is_premium
                                  //     ? "cartImageWidth cartImageWidthBlue"
                                  //     : "cartImageWidth"
                                  // }
                                  className="cartImageWidth"
                                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                                  alt="cart icon"
                                />
                              )}
                            </div>
                          </div>
                          {/* </div> */}
                          <div
                            onClick={() => {
                              if (localStorage.getItem("user")) {
                                setPackCardBs(card);
                                addtocart(card.id, card.slug);
                                setTimeout(() => {
                                  setState({ isPaneOpen: true });
                                }, 1000);
                              } else {
                                history.push({
                                  pathname: "/login",
                                  packageId: card.id,
                                });
                              }
                            }}
                            className="cart_div cart_textHeight"
                          >
                            <div>
                              {ItemInCart.includes(card.id) ? (
                                <div
                                  // className={
                                  //   card?.is_premium && prePack
                                  //     ? "hover_blue"
                                  //     : "hover_gray"
                                  // }
                                  className="hover_gray"
                                  onClick={() => {
                                    if (localStorage.getItem("user")) {
                                      setPackCardBs(card);
                                      addtocart(card.id, card.slug);
                                      setTimeout(() => {
                                        setState({ isPaneOpen: true });
                                      }, 1000);
                                    } else {
                                      history.push({
                                        pathname: "/login",
                                        packageId: card.id,
                                      });
                                    }
                                  }}
                                >
                                  <img
                                    // className={
                                    //   card?.is_premium && prePack
                                    //     ? "cartImageWidth cartImageWidthBlue"
                                    //     : "cartImageWidth"
                                    // }
                                    className="cartImageWidth"
                                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                                    alt="cart icon"
                                  />
                                </div>
                              ) : (
                                <div
                                  // className={
                                  //   card?.is_premium && prePack
                                  //     ? "hover_blue"
                                  //     : "hover_gray"
                                  // }
                                  className="hover_gray"
                                  onClick={() => {
                                    if (localStorage.getItem("user")) {
                                      setPackCardBs(card);
                                      addtocart(card.id, card.slug);
                                      setTimeout(() => {
                                        setState({ isPaneOpen: true });
                                      }, 1000);
                                    } else {
                                      history.push({
                                        pathname: "/login",
                                        packageId: card.id,
                                      });
                                    }
                                  }}
                                >
                                  <img
                                    // className={
                                    //   card?.is_premium && prePack
                                    //     ? "cartImageWidth cartImageWidthBlue"
                                    //     : "cartImageWidth"
                                    // }
                                    className="cartImageWidth"
                                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                                    alt="cart icon"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

            <div className="Package__card Package__cardLast bgOrdinary ">
              <Link
                className="viewAllLink"
                to={`/imaging/health-checkup-packages${
                  citySelected?.citySelect
                    ? `-${citySelected?.citySelect
                        .toLowerCase()
                        .replace(" ", "-")}`
                    : ""
                }`}
              >
                View All&nbsp;
                <AiOutlineRight />
              </Link>{" "}
            </div>
          </div>

          <div className="mobileViewAll">
            <button onClick={viewAllPackages} className="viewAllBtn">
              View All
            </button>
          </div>

          {Mobwidth >= 760 ? (
            <div>
              <div className="leftBtnProductListing">
                <button onClick={scrollLeft} className="BtnProductListing">
                  <AiOutlineRight />
                </button>
              </div>
              <div
                className={
                  hideRightBtn ? "displayNone1" : "rightBtnProductListing"
                }
              >
                <button onClick={scrollRight} className="BtnProductListing">
                  <AiOutlineLeft />
                </button>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {open && <FooterForm close={onCloseModal} />}

          {/* <Modal
            open={open}
            onClose={onCloseModal}
            // center
            classNames={{
              overlay: "customAddressOverlay",
              modal: "customAddressModal",
            }}
          >
            {" "}
            <div className="ImagingNewAddressPopup">
              <AddressPopUp
                butname={"SUBMIT"}
                title={"Book Your Test"}
                fromCart={cartClick}
                cartId={cartId}
                position={"Banner"}
                slug={cardSlug}
                Close={onCloseModal}
              />
            </div>
          </Modal> */}

          {/* <BookSlide
          ab={state}
          setab={setState}
          pacCardBs={pacCardBs}
          addToCart={addtocart}
        /> */}
        </div>
      </div>
      {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ fontSize: "1.8rem" }}
      /> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  CartItem: state?.CartReducer?.cartDetails,
});

// const mapDispatchToProps = (dispatch) => {
//   return {};
// };
const mapDispatchToProps = (dispatch) => {
  return {
    ImagingPackageList: (city) => {
      dispatch(ImagingPackageList(city));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OurPackages));
